import React from 'react'
import { ToolbarSection } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarSection'
import { ToolbarItem } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarItem'
import { defaultProps } from './index'
import * as icons from "@next-nx/shared-ui/icons"

export const ListImageBoxItemSettings = (props) => {
  
  const iconOpts = [
    ...[{ label: 'Nessuna', value: '' }],
    ...icons ? Object.keys(icons).filter(x => x.endsWith('Illustration')).map(x => ({
        label: x.replace('Illustration', '').replace(/[A-Z]/g, (m) => ' ' + m),
        value: x.replace(/[A-Z]/g, (m) => '_' + m.toLowerCase())
      })) : []
    ]

  return (
    <>
      <ToolbarSection title="Settings" initOpen>
        <ToolbarItem
          propKey="block"
          propSubKey="icon"
          type="select"
          options={iconOpts}
          label="Icona"
          defaultValue={defaultProps['icon']}
        />
      </ToolbarSection>
    </>
  );
};
